﻿module.exports = {
    bindings: {
        exciseCode: '<',
        group: '<',
        measuretitle: '<'
    },
    templateUrl: 'good/components/german-excise-measures.html'
};